import BizcontaLogo from '../../../assets/svg/biz-conta-title.svg';

import './bizos-logo.styles.scss';

const BizosLogo = () => {
    return (
        <div className="bizos-logo">
            <img src={BizcontaLogo} alt="Logo da Bizconta" />
        </div>
    );
}

export default BizosLogo;
